import { environment } from '../../../environments/environment';


export class ApiService {
  public API = `${environment.apiUrl}/api/`;
  public downloadApi = environment.apiUrl;
  public customerApi = environment.customerUrl;
}
